import { gql } from '@apollo/client';

export const REPORT_HEALTH_CHECKUP_INSTITUTIONS = gql`
  query reportHealthCheckupInstitutions($id: ID!, $limit: Int, $page: Int) {
    client {
      id
      regularHealthCheckupReport(id: $id) {
        id
        healthCheckupInstitutions(limit: $limit, page: $page) {
          totalCount
          list {
            id
            name
            location
          }
        }
      }
    }
  }
`;

export interface ReportHealthCheckupInstitutionsQueryVariables {
  id: string;
  limit?: number;
  page?: number;
}

export interface ReportHealthCheckupInstitutionsQueryResult {
  client: {
    id: string;
    regularHealthCheckupReport: {
      id: string;
      healthCheckupInstitutions: {
        totalCount: number;
        list: {
          id: string;
          name: string;
          location: string;
        }[];
      };
    };
  };
}
